import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Content2Header from "./Content2Header";
import ContentCreate from "./ContentCreate";

const Content = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Content2Header />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <ContentCreate />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Content;
